module.exports = "::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  margin: 0 !important;\n  display: inline-block !important;\n  width: auto !important;\n  height: auto !important;\n  overflow-x: hidden !important; }\n\n.header-danger {\n  background-color: #fa5c7c !important;\n  margin-top: -25px; }\n\n.body-modal {\n  padding: 2rem !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modals/rechazar-retiro-modal/rechazar-retiro-modal.component.scss
// module id = ./src/app/components/tools/modals/rechazar-retiro-modal/rechazar-retiro-modal.component.scss
// module chunks = main